module.exports = __webpack_public_path__ + "static/img/19.1c02558.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/zh/19.png
// module id = uIPT
// module chunks = 0